module.exports = __webpack_public_path__ + "static/media/icon-export.b74df6d8.svg";